// Course types that do NOT need email validation
export const noValidateTypes: string[] = ["flite", "demo"];
export const noValidateSites: string[] = ["cribl.myabsorb.com", "cribl-trough.myabsorb.com", "university.cribl.io", "localtest.me"];
export const demoHosts: string[] = ["demo.cribl.io", "demo-test.cribl.io"];